import FrequentQuestionBox from '~/themes/base/components/content/FrequentQuestionBox'

export default {
  extends: FrequentQuestionBox,
  data() {
    return {
      visibleFrequentQuestionBoxes: {},
    }
  },
  computed: {
    faqByCategory() {
      let byCategory = {}
      this.faqQuestions.forEach(q => {
        if (q.faq_categories_reference && q.faq_categories_reference[0]) {
          const categoryId = q.faq_categories_reference[0].entityId
          byCategory[categoryId] = byCategory[categoryId] || []
          byCategory[categoryId].push(q)
        }
      })
      return byCategory
    },
  },
  methods: {
    toggleFrequentQuestionBox(questionId) {
      this.$set(this.visibleFrequentQuestionBoxes, questionId, !this.visibleFrequentQuestionBoxes[questionId])
    },
  },
}
